import React, { useEffect, useState } from 'react'
import store from '../../store'
import { connect } from 'react-redux'

import { updatePnrEnqiryData, updatePnrEnqiryTripData } from '../../actions/search-actions'
import Trip from '../pnrEnquiry/trip'
import { renderSvg } from '../manageAccount/renderSvg'
import Obr from '../pnrEnquiry/obr'
import Mobile from '../pnrEnquiry/mobile'
import Email from '../pnrEnquiry/Email'
import MobileEmail from '../pnrEnquiry/mobileEmail';
import BusPnr from '../pnrEnquiry/busPnr'
import { tCommon, BUS_PNR, BUS_SER, EMAIL_BASED, ENQ, MOBILE_BASED, OB_REF,MOBILE_EMAIL_BASED_ENQ } from '../../translations/Common'

const BusTicketBook = () => {
    const [leftTabs, setLeftTabs] = useState(0);
    let params = new URLSearchParams(window.location.search);
    let obref = params.get("obref");

    useEffect(() => {
        if (obref) {
            setLeftTabs(1);
        }
    }, [])

    return (
        <div className="mainContent">
            <div className="leftContent">
                <div className="leftTabs">
                    <div className={`tabsContent ${leftTabs == 0 && "active"}`} onClick={() => { setLeftTabs(0); store.dispatch(updatePnrEnqiryData(false)); store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} })) }}>
                        {renderSvg("pnr")}
                        <span className="header-right-item-text">{tCommon(BUS_PNR)} <br /> {tCommon(ENQ)}</span>
                    </div>
                    <div className={`tabsContent ${leftTabs == 1 && "active"}`} onClick={() => { setLeftTabs(1); store.dispatch(updatePnrEnqiryData(false)); store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} })) }}>
                        {renderSvg("currency")}
                        <span className="header-right-item-text">{tCommon(OB_REF)} <br /> {tCommon(ENQ)}</span>
                    </div>
                    {/* <div className={`tabsContent ${leftTabs == 2 && "active"}`} onClick={() => { setLeftTabs(2); store.dispatch(updatePnrEnqiryData(false)); store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} })) }}>
                        {renderSvg("mobile")}
                        <span className="header-right-item-text">{tCommon(MOBILE_BASED)} <br /> {tCommon(ENQ)}</span>
                    </div>
                    <div className={`tabsContent ${leftTabs == 3 && "active"}`} onClick={() => { setLeftTabs(3); store.dispatch(updatePnrEnqiryData(false)); store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} })) }}>
                        {renderSvg("email")}
                        <span className="header-right-item-text">{tCommon(EMAIL_BASED)} <br /> {tCommon(ENQ)}</span>
                    </div> */}
                    <div className={`tabsContent ${leftTabs == 5 && "active"}`} onClick={() => { setLeftTabs(5); store.dispatch(updatePnrEnqiryData(false)); store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} })) }}>
                        {renderSvg("mobile")}
                        <span className="header-right-item-text">{tCommon(MOBILE_EMAIL_BASED_ENQ)}</span>
                    </div>
                    <div className={`tabsContent ${leftTabs == 4 && "active"}`} onClick={() => { setLeftTabs(4); store.dispatch(updatePnrEnqiryData(false)); store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} })) }}>
                        {renderSvg("service")}
                        <span className="header-right-item-text">{tCommon(BUS_SER)} <br /> {tCommon(ENQ)}</span>
                    </div>
                </div>
            </div>
            <div className="rightContent">
                {leftTabs == 0 && <BusPnr />}
                {leftTabs === 1 && <Obr val={obref || ""} />}
                {/*leftTabs === 2 && <Mobile />*}
                {/*leftTabs === 3 && <Email />*/}
                {leftTabs === 4 && <Trip />}
                {leftTabs === 5 && <MobileEmail />}
            </div>
        </div>
    )
}


const mapStateToProps = function (store) {
    return store;
};
export default connect(mapStateToProps)(BusTicketBook);